import Modal from "./Modal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

function ModalDMESetupReminder({ close }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSetupNow = () => {
    close();
    navigate("/settings/billing");
  };

  const handleRemindLater = () => {
    close();
  };

  return (
    <Modal close={close} title={t("dmeBilling.reminder.title", "Complete Your DME Billing Setup")} show={true} size="small">
      <div className="dme-reminder-content">
        <div className="reminder-icon mb-20">
          <i className="material-symbols-outlined">receipt_long</i>
        </div>

        <p className="mb-20">
          {t(
            "dmeBilling.reminder.message",
            "To start ordering collagen products, you need to complete your DME billing setup. This only takes a few minutes."
          )}
        </p>

        <ul className="reminder-benefits mb-20">
          <li>{t("dmeBilling.reminder.benefit1", "Enable product ordering for your organization")}</li>
          <li>{t("dmeBilling.reminder.benefit2", "Set up compliant billing arrangements")}</li>
          <li>{t("dmeBilling.reminder.benefit3", "Get credentialing support if needed")}</li>
        </ul>
      </div>

      <div className="modal-actions btn-bar">
        <button className="btn btn-secondary" onClick={handleRemindLater}>
          {t("common.dismiss")}
        </button>
        <button className="btn btn-primary" onClick={handleSetupNow}>
          {t("dmeBilling.reminder.setupNow", "Set Up Now")}
        </button>
      </div>
    </Modal>
  );
}

export default ModalDMESetupReminder;
